import { render } from "./CatalogsSentHistory.vue?vue&type=template&id=3013ac30&ts=true"
import script from "./CatalogsSentHistory.vue?vue&type=script&lang=ts"
export * from "./CatalogsSentHistory.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__